import React, { useEffect, useRef } from 'react';

const MatrixRain = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      ctx.fillStyle = "black";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const letters = "アカサタナハマヤラワ0123456789SIM";
    const baseFontSize = 16;
    const columns = Math.floor(canvas.width / baseFontSize);

    const drops = Array(columns).fill(1);
    const speeds = Array(columns).fill(0).map(() => 0.3 + Math.random() * 1.0);
    const depths = Array(columns).fill(0).map(() => Math.random());

    const draw = () => {
      // softer trails
      ctx.fillStyle = "rgba(0, 0, 0, 0.15)";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      for (let i = 0; i < drops.length; i++) {
        const depth = depths[i];

        const fontSize = baseFontSize * (0.85 + depth * 0.4);
        const speed = speeds[i] * (0.5 + depth * 0.8);

        ctx.font = fontSize + "px monospace";

        const x = i * baseFontSize;
        const y = drops[i] * baseFontSize;

        const text = letters[Math.floor(Math.random() * letters.length)];

        // toned-down brightness
        const brightness = 0.15 + depth * 0.6;

        // TRAIL
        ctx.shadowBlur = 0;
        ctx.fillStyle = `rgba(0,255,255,${0.08 * brightness})`;
        ctx.fillText(text, x, y - fontSize * 2);

        ctx.fillStyle = `rgba(0,255,255,${0.15 * brightness})`;
        ctx.fillText(text, x, y - fontSize);

        // BODY
        ctx.fillStyle = `rgba(0,255,255,${0.3 * brightness})`;
        ctx.fillText(text, x, y);

        // SOFTER HEAD
        ctx.shadowColor = "rgba(0,255,255,0.6)";
        ctx.shadowBlur = 6 + depth * 8;
        ctx.fillStyle = `rgba(0,255,255,${0.5 + depth * 0.3})`;
        ctx.fillText(text, x, y);

        ctx.shadowBlur = 0;

        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
          depths[i] = Math.random();
          speeds[i] = 0.3 + Math.random() * 1.0;
        }

        drops[i] += speed;
      }
    };

    const interval = setInterval(draw, 45);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed top-0 left-0 w-full h-full z-[1] pointer-events-none blur-[1.5px]"
    />
  );
};

export default MatrixRain;